const painCards = [
  {
    icon: "ri-refresh-line",
    title: "You repaired it. It came back.",
    desc: "The same crack, the same wall, the same problem — weeks or months after the contractor left.",
  },
  {
    icon: "ri-money-dollar-circle-line",
    title: "You spent $10,000. Six months later — water again.",
    desc: "The invoice was paid. The warranty was given. And yet, the water found its way back in.",
  },
  {
    icon: "ri-group-line",
    title: "Residents are complaining. Management is under pressure.",
    desc: "Calls, emails, complaints. The board is asking questions you don't have answers to.",
  },
  {
    icon: "ri-question-answer-line",
    title: "Every contractor has a different explanation. None of them worked.",
    desc: "One says it's the membrane. Another says it's the joint. A third says it's the drainage. All wrong.",
  },
];

export default function PainSection() {
  return (
    <section id="pain" className="bg-[#0a0e1a] py-20 md:py-28">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-[#4a7fa5] font-bold uppercase tracking-widest text-sm mb-3">The Cycle That Never Ends</p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white">Sound familiar?</h2>
        </div>

        {/* Pain cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-12">
          {painCards.map((card) => (
            <div
              key={card.title}
              className="bg-[#0f1525] border border-red-900/40 rounded-lg p-6 flex gap-4 hover:border-red-600/60 transition-colors"
            >
              <div className="flex-shrink-0 w-12 h-12 flex items-center justify-center rounded-full bg-red-900/30 border border-red-700/40">
                <i className={`${card.icon} text-red-400 text-xl`}></i>
              </div>
              <div>
                <h3 className="text-white font-bold text-base mb-2">{card.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Bold closer */}
        <div className="bg-[#0f1525] border-l-4 border-[#1a3a5c] rounded-lg px-6 py-5 max-w-3xl mx-auto text-center">
          <p className="text-white text-lg md:text-xl font-bold leading-snug">
            The repair didn&apos;t fail because of bad luck.{" "}
            <span className="text-[#4a7fa5]">It failed because the source was never treated.</span>
          </p>
        </div>
      </div>
    </section>
  );
}
